<template>
  <div class="content">
    <div
      class="mix-list-cell"
      :class="border"
      @click="eventClick"
      hover-class="cell-hover"
      :hover-stay-time="50"
    >
      <span
        v-if="icon"
        class="cell-icon yticon"
        :style="[{
					color: iconColor,
				}]"
        :class="icon"
      ></span>
      <span class="cell-tit clamp">{{title}}</span>
      <span v-if="tips" class="cell-tip">{{tips}}</span>
      <span class="cell-more yticon" :class="typeList[navigateType]"></span>
    </div>
  </div>
</template>
 
<script>
/**
 *  简单封装了下， 应用范围比较狭窄，可以在此基础上进行扩展使用
 *  比如加入image， iconSize可控等
 */
export default {
  data () {
    return {
      typeList: {
        left: 'icon-zuo',
        right: 'icon-you',
        up: 'icon-shang',
        down: 'icon-xia'
      },
    }
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '标题'
    },
    tips: {
      type: String,
      default: ''
    },
    navigateType: {
      type: String,
      default: 'right'
    },
    border: {
      type: String,
      default: 'b-b'
    },
    hoverClass: {
      type: String,
      default: 'cell-hover'
    },
    iconColor: {
      type: String,
      default: '#333'
    }
  },
  methods: {
    eventClick () {
      this.$emit('eventClick');
    }
  },
}
</script>

<style lang='scss' scoped>
.icon .mix-list-cell.b-b:after {
  left: 45px;
}
.mix-list-cell {
  display: flex;
  align-items: baseline;
  padding: 10px $page-row-spacing;
  line-height: 30px;
  position: relative;

  &.cell-hover {
    background: #fafafa;
  }
  &.b-b:after {
    left: 15px;
  }

  .cell-icon {
    align-self: center;
    width: 28px;
    max-height: 30px;
    font-size: 19px;
  }
  .cell-more {
    align-self: center;
    font-size: 15px;
    color: $font-color-base;
    margin-left: $uni-spacing-row-sm;
  }
  .cell-tit {
    flex: 1;
    font-size: $uni-font-size-base;
    color: $font-color-dark;
    margin-right: 5px;
  }
  .cell-tip {
    font-size: $uni-font-size-sm + 1px;
    color: $font-color-light;
  }
}
</style>
